import styled from "styled-components";
import Typography from "@material-ui/core/Typography"
import TableCell from '@material-ui/core/TableCell'
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';


export const HeaderTypo = styled.h3`
    display:block;
    background-color: #33383e !important;
    padding: 0.4rem 0 !important;
    color: #ffffff;
    font-family: "HelveticaNeue" !important;
    font-size: 19px ;
    text-align: center;
    font-weight: 400;
    margin:0;
    margin-bottom: 20px;
    border-radius: 10px 10px 0 0;

    span{
        font-size: 24px !important;
    }
`

export const StyledPanelSummary = styled(ExpansionPanelSummary)`
    margin-top: 0 !important;
    display:block !important;
    padding: 0 !important;
    transition: margin 150ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
    
    div{
        display: block !important;
        margin-bottom: 0 !important;
    }
    &.separate {
        margin-bottom: 15px;
        transition: margin 150ms cubic-bezier(0.4, 0, 0.2, 1) 0ms
    }
`
export const BordedBox = styled.div`
    border: 1px solid #d1cfc8;
    border-radius: 10px;
    padding-left: 1rem; 

` 

export const StyledTableTd = styled.td`
    border-bottom: none !important;
    color: rgb(51, 56, 62);
    font-family: HelveticaNeueBold;
    font-size: 13px !important;
    letter-spacing: 1px;

    &.light {
        color: rgba(0, 0, 0, 0.54);
        font-weight: bold;
    }
    &.big {
        font-size: 1.2rem !important;
    }
    &.grow{
        padding-left: 0;
        padding-right:0rem;
    }
    &.head{
        width:25%;
    }

`

export const StyledTableRowHead = styled.thead`
    display: flex;
    justify-content: space-between;
    align-items: center;
`
export const InfoSpan = styled.p`
    font-size: 13px !important;
    margin:0;
`


// WEBPACK FOOTER //
// ./src/components/styles/boxPaymentsClients/style.js